import { render, staticRenderFns } from "./UploadAvatarImage.vue?vue&type=template&id=1e99257c&scoped=true&"
import script from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
export * from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatarImage.vue?vue&type=style&index=0&id=1e99257c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99257c",
  null
  
)

export default component.exports